export type FolderTypology = {
  folderTypologyId: string;
  descriptionTranslationKey: string;
};

export type FolderTypologyResponse = {
  preFolderTypologyOfFolderResponseList: FolderTypology[];
};

export enum FOLDER_TYPOLOGIES {
  BORDERC_ROSSING_RORO_EMPTY_DESCRIPTION = 'BORDERCROSSING_RORO_EMPTY_DESCRIPTION',
  BORDER_CROSSING_RORO_FULL_DESCRIPTION = 'BORDERCROSSING_RORO_FULL_DESCRIPTION',
}
